// Import slick css files
import '../../styles/componentStyles/slick.scss';
import '../../styles/componentStyles/slick-theme.scss';

import Divider from '../Atoms/Divider';
import Card from '../Molecules/Card';
import TextBox from '../Atoms/TextBox';
import React, { useState, Component } from 'react';
import Slider from "react-slick";
import { client } from '../../client';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import {isMobile} from 'react-device-detect';





      
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  // console.log("className: " + className); == // slick-arrow slick-next
  return (
    <div

      className={className}
      style={{ display: "flex",  background: "none", flexWrap: "wrap", justifyContent: "center", overflow: "hidden", width:"20%"}}
      onClick={onClick}
    >
    
    {/* <p className="slick-label" style={{ color: "#000", display: "flex", paddingRight: "10px"  }}> NEXT <span style={{ width: "60px" }}></span></p> */}
    
    </div>
  );  
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ display: "flex", background: "none", flexWrap: "wrap", justifyContent: "center", overflow: "hidden", width:"20%"}}
      onClick={onClick}
    >
    
    {/* <p className="slick-label" style={{ color: "#000", display: "flex", paddingRight: "10px"  }}> BACK<span style={{ width: "60px" }}></span></p> */}
    
    </div>
  );
}

class HeroSlider extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      imagesCarousel: []
    }  

  }

  //this is where we receive API calls inside components
  componentDidMount() {
    client.getEntries()
      .then((response) => {
        this.setState({
          imagesCarousel: response.fields.imagesCarousel
        
        })
    })
    .catch(console.error)
  }
  
 

  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />

    };

    // this.props.videoLinks ? console.log(this.props.videoLinks) : "";
    

    const videoHeight = isMobile ? 300 : 560;

    return (
          <Slider className="hero-slider margin-b-xl" {...settings}>
            
            {this.props.videoLinks ?
              this.props.videoLinks.map((videoLink, index) => (
                //Embedding youtube video with youtube ID input
                <iframe width="720" height={videoHeight} src={`https://www.youtube.com/embed/${videoLink}?rel=0`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              )
              
              )
              
              :
              null

              }

            
              
              
              
              
            

              {this.props.images.map((imageCarouselImage, index) => (
                <img className="hero-slider-image fit-contain" src={`${imageCarouselImage.fields.file.url}?w=1200&h=800&fm=jpg&fl=progressive`} key={index}></img>
                // <h1>🎉</h1>
                
              )
              
              )}
              


              
        </Slider>

    );
  }
}



export default HeroSlider;



